import React from "react";
import EstudosIranduba from "./EstabelecimentosEstudos/EstudosIranduba";
import EstudosRestantes from "./EstabelecimentosEstudos/EstudosRestantes";
import EstudosOuroBranco from "./EstabelecimentosEstudos/EstudosOuroBranco";

const Estudos = () => {
    switch (localStorage.getItem("entidade_id")) {
        case "33":
            return <EstudosIranduba />;
        case "37":
            return <EstudosOuroBranco />;
        default:
            return <EstudosRestantes />;
    }
};

export default Estudos;
